
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData', 'compStylableClass'],
      ({ compData, compStylableClass }) => {
        return {
          ...{"steps":[{"label":"Completed step"},{"label":"Error step","value":"error"},{"label":"Normal step","value":"disabled"},{"label":"Disabled step","value":"completed"}],"fit":"compact","activeStep":0},
          ...compData,
          className: compStylableClass
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  